import { module as BaseModule } from 'modujs';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

function checkOverflow(swiper) {
  const totalWidth = [...swiper.slides].reduce((sum, s) => sum + s.offsetWidth, 0);
  // Find navigation elements relative to swiper
  const root = swiper.el.closest('[data-module-slider]') || swiper.el.parentElement;
  const prevEl = root ? root.querySelector('[data-slider-prev]') : null;
  const nextEl = root ? root.querySelector('[data-slider-next]') : null;
  const navEl = root ? root.querySelector('[data-slider-nav]') : null;
  const fitsOneRow = totalWidth <= swiper.width + 1;

  if (fitsOneRow) {
    swiper.wrapperEl.style.justifyContent = 'center';
    swiper.wrapperEl.style.transform = 'none'; // prevent swiper from fighting CSS
    // Hide navigation if found
    if (prevEl) prevEl.style.display = 'none';
    if (nextEl) nextEl.style.display = 'none';
    if (navEl) navEl.hidden = true;
  } else {
    swiper.wrapperEl.style.justifyContent = '';
    // Show navigation if found
    if (prevEl) prevEl.style.display = '';
    if (nextEl) nextEl.style.display = '';
    if (navEl) navEl.hidden = false;
  }
}

/**
 * Initialize (or re-initialize) every [data-slider] inside a [data-module-slider] root.
 * Shared by frontend modujs and the block editor canvas.
 *
 * @param {HTMLElement} el
 * @param {{ force?: boolean }} [options] - force=true destroys existing Swiper instances first
 */
export function initSliderRoot(el, { force = false } = {}) {
  if (!el) return;

  const sliders = el.querySelectorAll('[data-slider]');
  const prevEl = el.querySelector('[data-slider-prev]');
  const nextEl = el.querySelector('[data-slider-next]');

  const breakpoints = el.getAttribute('data-slider-breakpoints') !== null
    ? JSON.parse(el.getAttribute('data-slider-breakpoints'))
    : {};

  const loop = el.getAttribute('data-slider-loop') === '1'
    || el.getAttribute('data-slider-loop') === null;

  const config = {
    modules: [Navigation],
    speed: 400,
    watchOverflow: true,
    navigation: {
      nextEl,
      prevEl,
    },
    loop,
    breakpoints,
  };

  if (el.getAttribute('data-slider-centering') === '1') {
    config.on = {
      init(swiper) {
        checkOverflow(swiper);
      },
      resize(swiper) {
        checkOverflow(swiper);
      },
    };
  }

  sliders.forEach((slider) => {
    if (slider.swiper && !force) {
      slider.classList.remove('opacity-0');
      return;
    }

    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }

    new Swiper(slider, config);
    slider.classList.remove('opacity-0');
  });
}

export default class extends BaseModule {
  constructor(m) {
    super(m);
  }

  init() {
    initSliderRoot(this.el);
  }
}
